import React from "react";

/* ═══════════════════════════════════════════════════════════
   HERO — The Statement
   Massive Playfair Display · clip-path line reveals
   Cursor parallax on floating orbs · scroll cue
   ═══════════════════════════════════════════════════════════ */

const Hero = () => {
  return (
    <section
      id="top"
      className="relative min-h-screen flex flex-col justify-center overflow-hidden"
    >
      {/* Floating parallax orbs */}
      <div
        className="orb orb-gold w-[40rem] h-[40rem] -top-40 -right-40"
        data-parallax="0.3"
        aria-hidden="true"
      />
      <div
        className="orb orb-obsidian w-[30rem] h-[30rem] top-1/3 -left-40"
        data-parallax="0.2"
        aria-hidden="true"
      />
      <div
        className="orb orb-silver w-[25rem] h-[25rem] bottom-0 right-1/4"
        data-parallax="0.15"
        aria-hidden="true"
      />

      {/* Content */}
      <div className="lux-container relative z-10 pt-32 pb-20">
        <div className="max-w-5xl">
          {/* Eyebrow */}
          <p
            className="lux-eyebrow mb-8"
            data-parallax="0.05"
          >
            Software Engineer · India
          </p>

          {/* Massive statement with line reveals */}
          <h1 className="lux-hero">
            <span className="reveal-line">
              <span>Crafting</span>
            </span>
            <span className="reveal-line">
              <span className="lux-gold">Digital</span>
            </span>
            <span className="reveal-line">
              <span>Elegance</span>
            </span>
          </h1>

          {/* Sub copy */}
          <p
            className="lux-body max-w-xl mt-10"
            data-parallax="0.08"
          >
            I build refined software solutions, intuitive interfaces, and
            web applications — where precision meets poetry, and every
            pixel is intentional.
          </p>

          {/* CTAs */}
          <div className="flex flex-wrap gap-5 mt-12" data-parallax="0.06">
            <a
              href="#work"
              className="lux-btn"
              data-magnetic="0.3"
            >
              View Work
              <span aria-hidden="true">→</span>
            </a>
            <a
              href="#contact"
              className="lux-btn-ghost"
              data-magnetic="0.2"
            >
              Get in Touch
            </a>
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-4">
        <span className="font-grotesk text-[0.6rem] tracking-[0.4em] uppercase text-silver-500">
          Scroll
        </span>
        <div className="scroll-cue" aria-hidden="true" />
      </div>
    </section>
  );
};

export default Hero;